
import React from 'react';
// LAYOUTS
import { ContainerLeft } from '../ContainerLeft/ContainerLeft'
import { ContainerRight } from '../ContainerRight/ContainerRight'

export const MainHome = () => {
  return (
    <main className='mainHome'>
      <ContainerLeft />
      
      <ContainerRight />
    </main>
  )
}
